import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../redux/store.tsx";
import { fetchStaticContent } from "../../redux/features/contentManagement/readonlyContentThunk.tsx";
import { CircularProgress } from "@mui/material";
import { useNavigate } from "react-router-dom";

const TermsAndConditionsPage = () => {
  const navigate = useNavigate();

  const dispatch = useDispatch<AppDispatch>();
  const { content, loading, error } = useSelector(
    (state: RootState) => state.staticContent
  );

  useEffect(() => {
    dispatch(fetchStaticContent(4)); // 1 for privacy policy
  }, [dispatch]);

  const handleLogoClick = () => {
    navigate("/");
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <CircularProgress />
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen bg-gray-100 flex items-center justify-center">
        <p className="text-red-500">Error: {error}</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col items-center">
      <header className="w-full bg-white p-4 md:pl-8 lg:pl-12 shadow-md flex items-center">
        <img
          src="/assets/Aria-Logo.png"
          alt="Aria Logo"
          className="cursor-pointer h-10 transition-all duration-300 ease-in-out"
          onClick={handleLogoClick}
        />
      </header>

      <main className="flex-1 w-full p-6 md:p-8 lg:p-12">
        <h1 className="text-4xl font-bold mb-6 text-center">
          Terms and Conditions
        </h1>

        <div
          className="bg-white p-6 rounded-lg shadow-lg htmlContent"
          dangerouslySetInnerHTML={{ __html: content?.content || "" }}
        >
          {/* {content && parse(content.content)} */}
        </div>
      </main>

      <footer className="w-full bg-white p-4 shadow-md text-center">
        <p className="text-gray-600">
          © {new Date().getFullYear()} Aria Vacation Timeshare Rentals LLC. All
          rights reserved.
        </p>
      </footer>
    </div>
  );
};

export default TermsAndConditionsPage;
